import { UIButton, UIControl, UIView, UIViewController } from "uikit";
import { BookingProductCategoryViewController, BookingProductCategoryViewControllerDelegate } from "./BookingProductCategoryViewController";
import { BookingProductViewController, BookingProductProtocolDelegate } from "./BookingProductViewController";
import { BookingCalendarViewController } from "./BookingCalendarViewController";
import { BookingClientProtocolDelegate, BookingClientViewController } from "./BookingClientViewController";
import { BookingRestaurantViewController } from "./BookingRestaurantViewController";
import { BookingViewController } from "./BookingViewController";

export class BookingDesktopViewController extends BookingViewController implements BookingProductProtocolDelegate, BookingProductCategoryViewControllerDelegate, BookingClientProtocolDelegate
{
    private productCategoryView:UIView;
    private productView:UIView;
    private calendarView:UIView;    
    private restaurantView:UIView;    
    private clientView:UIView;    

    viewDidLoad(){
        super.viewDidLoad();

        if (this.productCategoryView) {
            this.productCategoryViewController = new BookingProductCategoryViewController();
            this.productCategoryViewController.initWithNibName( "BookingProductCategoryView" );
            this.productCategoryViewController.delegate = this;
            
            this.productCategoryView.addSubview( this.productCategoryViewController.view );
            this.addChildViewController( this.productCategoryViewController );
        }

        // Add Booking product view controller
        if (this.productView) {
            this.productViewController = new BookingProductViewController();
            this.productViewController.initWithNibName( "BookingProductView" );
            this.productViewController.delegate = this;

            this.productView.addSubview( this.productViewController.view );
            this.addChildViewController( this.productViewController ); 

            this.stepViewControllers.push( this.productViewController );
        }
        
        // Add Booking calendar view controller
        if (this.calendarView) {
            this.calendarViewController = new BookingCalendarViewController();
            this.calendarViewController.initWithNibName( "BookingCalendarView" );
            this.calendarViewController.delegate = this;

            this.calendarView.addSubview( this.calendarViewController.view );
            this.addChildViewController( this.calendarViewController );  

            this.stepViewControllers.push( this.calendarViewController );
        }      

        // Add Booking restaurant view controller
        if (this.restaurantView) {
            this.restaurantViewController = new BookingRestaurantViewController();
            this.restaurantViewController.initWithNibName( "BookingRestaurantView" );
            this.restaurantViewController.delegate = this;

            this.restaurantView.addSubview( this.restaurantViewController.view );
            this.addChildViewController( this.restaurantViewController );

            this.stepViewControllers.push( this.restaurantViewController );
        }
        
        // Add client view 
        if (this.clientView) {
            this.clientViewController = new BookingClientViewController();
            this.clientViewController.initWithNibName( "BookingClientView" );
            this.clientViewController.delegate = this;

            this.clientView.addSubview( this.clientViewController.view );
            this.addChildViewController( this.clientViewController );

            this.stepViewControllers.push( this.clientViewController );
        }
        
    }

    onCalendarDidChange ( vc: BookingCalendarViewController, date:string )
    {
        super.onCalendarDidChange( vc, date );
        this.restaurantViewController.setDate( date ) ;
    }

    onNumPeopleDidChange ( vc: BookingCalendarViewController, numberOfPeople:number )
    {      
        super.onNumPeopleDidChange( vc, numberOfPeople );
        this.restaurantViewController.setNumPeople( numberOfPeople ) ;
    }
    
    onNumProductDidChange ( vc: BookingProductViewController, numberOfProducts:number ) {
        super.onNumProductDidChange( vc, numberOfProducts );
        this.calendarViewController.setNumPeople( numberOfProducts ) ;
        this.restaurantViewController.setNumPeople( numberOfProducts ) ;
    }

    categoryDidChange ( vc: BookingProductCategoryViewController, categoryID:string ) {
        this.productViewController.fetchProducts( categoryID );
    }

    onClientFormDidChange ( vc: BookingClientViewController ) {
        super.onClientFormDidChange( vc );
    }
}